import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../../product-card/product-card-display';
import emit from '../../../common/events';
import { getPaginationMessage } from '../utils/pagination.utils';
import { PaginationBase } from '../pagination-base';
import "../message/pagination-message";

/**
 * An element to paginate search results in memory.
 * This component needs to be re-rendered every time
 * the pagination ocurrs and the parent update the results
 * on the list.
 * 
 * For the other components using this component, they must implement
 * the UsePaginationInMemory interface, which request the updatePagination
 * method implementation
 *
 * @event go-to-page-in-memory - A user has clicked a page within the pagination.
 *        <br><br><span style="color: green">&check;</span> dataLayer
 *        <br><span style="color: green">&check;</span> bubbles
 *        <br><br>event.detail: { searchTerms, catalog, pageLength, start, facets }
 */
@customElement('mhecomm-pagination-in-memory')
export class PaginationInMemory extends PaginationBase {

  renderComp() {
    this.updatePages();
    return super.paginationComponent();
  }

  override showPaginationMsg() {
    return html`
      <mhecomm-pagination-message
        ?useRawMessage=${true}
        message="${getPaginationMessage(this.currentPage, this.pageLength, this.total)}"
        id="pagination_message"
        data-automation-id="pagination_message"
      >
      </mhecomm-pagination-message>
    `;
  }

  override goToPageHook(pageIndex: number): void {
    this.currentPage = pageIndex;
    const stickyTopElementHeight = document.querySelector('.sticky-top')?.clientHeight;
    if (stickyTopElementHeight) {
      window.scrollTo({
        top: stickyTopElementHeight,
        behavior: 'smooth',
      });
    const activePageId = `page-${pageIndex + 1}`;
    setTimeout(() => {
      this.shadowRoot?.getElementById(activePageId)?.focus();
    }, 100);
    } else {
      this.scrollTo();
    }
  }

  override emitAnalytics(pageIndex: number): void {
    emit({
      element: this,
      name: 'go-to-page-in-memory',
      detail: { 
        paginationNumber: pageIndex + 1
      },
      dataLayer: true,
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-pagination-in-memory': PaginationInMemory;
  }
}
